import style from "../koreanKpassStandardization.module.scss";

export function ArticleFooterKO() {
  return <section className={style.articleFooter}></section>;
}
